//#region node_modules/.deno/rambda@9.4.2/node_modules/rambda/src/type.js
function type(input) {
	if (input === null) return "Null";
	else if (input === void 0) return "Undefined";
	else if (Number.isNaN(input)) return "NaN";
	const typeResult = Object.prototype.toString.call(input).slice(8, -1);
	return typeResult === "AsyncFunction" ? "Promise" : typeResult;
}

//#endregion
export { type };